<template>
  <el-select v-if="sections && sections.length > 0" v-model="sectionId" class="bg-dark" placeholder="Select"
    size="large" @change="$emit('selected-section-id', sectionId)">
    <el-option v-for="{ section_id, name } in sections" :key="section_id" :label="name" :value="section_id" />
  </el-select>
</template>

<script>
import { ref, watch } from "vue";
import store from "@/store";

export default {
  name: "SectionDropdown",
  props: {
    allowAll: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Number,
      default: -1,
    },
  },
  emits: ["selected-section-id"],
  setup(props) {
    let sectionId = ref(props.selected);
    if (sectionId.value == -1 && !props.allowAll) {
      sectionId.value = "";
    }
    watch(
      () => props.selected,
      (current) => {
        if (current == -1 && !props.allowAll) sectionId.value = "";
        else sectionId.value = current;
      }
    );
    return { sectionId };
  },
  data() {
    return {
      sections: [],
    };
  },
  created() {
    store
      .dispatch("list/getSections", { sort: "name", order: "asc" })
      .then((res) => {
        this.sections = res.data;
        if (this.allowAll) {
          this.sections.unshift({ section_id: -1, name: "All Sections" });
        }
      });
  },
};
</script>

<style></style>
